export const enUS = {
  // Navigation
  nav: {
    home: 'Home',
    transport: 'Transport',
    stay: 'Accommodation',
    tickets: 'Tickets',
    cowork: 'Coworking',
    culture: 'Culture',
    nomad: 'Nomad Community',
  },
  
  // Home page
  home: {
    hero: {
      title: 'Hualien Digital Nomad Platform',
      subtitle: 'Explore Hualien\'s natural beauty while enjoying the perfect digital work environment',
      cta: 'Start Exploring',
    },
    quickNav: {
      title: 'Quick Navigation',
      transport: 'Transport',
      stay: 'Accommodation',
      tickets: 'Tickets',
      cowork: 'Coworking',
      culture: 'Culture',
    },
    featured: {
      title: 'Featured Activities',
      summerFestival: 'Hualien Summer Festival',
      whaleWatching: 'Whale Watching',
      hiking: 'Taroko Hiking',
    },
  },
  
  // Transport page
  transport: {
    title: 'Transport & Shuttle Booking',
    fromTaipei: 'From Taipei to Hualien',
    toAccommodation: 'Airport to Accommodation Shuttle',
    rental: 'Vehicle Rental',
    methods: {
      hsr: 'HSR + Shuttle',
      train: 'Train',
      plane: 'Plane',
    },
    form: {
      departure: 'Departure',
      destination: 'Destination',
      date: 'Date',
      time: 'Time',
      passengers: 'Passengers',
      vehicleType: 'Vehicle Type',
      duration: 'Duration',
      submit: 'Book',
    },
  },
  
  // Stay page
  stay: {
    title: 'Accommodation',
    filters: {
      price: 'Price',
      type: 'Type',
      nomadFriendly: 'Nomad Friendly',
      all: 'All',
      hotel: 'Hotel',
      hostel: 'Hostel',
      homestay: 'Homestay',
    },
    card: {
      perNight: 'per night',
      wifi: 'Wi-Fi',
      longTerm: 'Long-term discount',
      viewDetails: 'View Details',
    },
  },
  
  // Tickets page
  tickets: {
    title: 'Activity Tickets',
    addToCart: 'Add to Cart',
    selectDate: 'Select Date',
    selectTime: 'Select Time',
    participants: 'Participants',
    meetingPoint: 'Meeting Point',
    price: 'Price',
    bookNow: 'Book Now',
  },
  
  // Coworking page
  cowork: {
    title: 'Coworking Spaces',
    daily: 'Daily',
    weekly: 'Weekly',
    monthly: 'Monthly',
    features: {
      wifi: 'Wi-Fi',
      power: 'Power Outlets',
      meeting: 'Meeting Room',
      coffee: 'Coffee',
    },
    speed: 'Speed',
    hours: 'Hours',
  },
  
  // Culture page
  culture: {
    title: 'Cultural Experiences',
    book: 'Book',
    maxParticipants: 'Max Participants',
    languages: 'Languages',
    timeSlots: 'Available Times',
  },
  
  // Nomad page
  nomad: {
    title: 'Digital Nomad Community',
    events: 'Events',
    interested: 'Interested',
    comment: 'Comment',
    languageExchange: 'Language Exchange',
    workMeetup: 'Work Meetup',
  },
  
  // User menu
  user: {
    login: 'Login',
    logout: 'Logout',
    profile: 'Profile',
    language: 'Language',
    chinese: '繁體中文',
    english: 'English',
  },
  
  // Common
  common: {
    loading: 'Loading...',
    error: 'Error occurred',
    success: 'Success',
    cancel: 'Cancel',
    confirm: 'Confirm',
    back: 'Back',
    next: 'Next',
    search: 'Search',
    filter: 'Filter',
    sort: 'Sort',
  },
}; 